<mat-card class="monitoring-report">
    <div class="report-header">
        <div>
            <h4>4GLTE and Overlay Billing Report <span *ngIf="org">for {{org.name}}</span></h4>
        </div>
        <div class="report-actions">
            <button mat-raised-button color="primary" class="btn btnn" (click)="loadData()">
                <mat-icon>search</mat-icon>
                <span>Search</span>
            </button>
            <button mat-stroked-button color="primary" class="btn btnn" (click)="exportToExcel()">
                <mat-icon>file_download</mat-icon>
                <span>Export</span>
            </button>
        </div>
    </div>
    <div class="report-filters" [formGroup]="searchForm">        
        <mat-form-field appearance="outline">
            <mat-label>Select Month</mat-label>
            <mat-select formControlName="month" (selectionChange)="onSelectMonth($event)">
                <mat-option *ngFor="let item of months" [value]="item.value">
                    {{ item.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Select Year</mat-label>
            <mat-select formControlName="year" (selectionChange)="onSelectYear($event)">
                <mat-option *ngFor="let item of years" [value]="item">
                    {{ item }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="currentRole == 0">
            <mat-label>MMSP</mat-label>
            <mat-select formControlName="mmsp" (selectionChange)="onSelectMMSP($event)">
                <div class="dropdown-search" *ngIf="mmspList.length > 1">
                    <input [(ngModel)]="mmspSearchPipe" [ngModelOptions]="{standalone: true}" matInput
                        (ngModelChange)="filterMmspOptions($event)"
                        placeholder="Search MMSP" autocomplete="off">
                </div>
                <mat-option *ngFor="let organization of filteredMmspList; trackBy: trackByOrgId" [value]="organization.orgId">
                    {{ organization.name }} ({{ (organization.role == 0? "Root": organization.role
                    == 1? "Master Msp":organization.role == 2? "Msp": organization.role == 3?
                    "Organization": "") }})
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>MSP</mat-label>
            <mat-select formControlName="msp" (selectionChange)="onSelectMSP($event)">
                <div class="dropdown-search" *ngIf="mspList.length > 1">
                    <input [(ngModel)]="mspSearchPipe" [ngModelOptions]="{standalone: true}" matInput
                        (ngModelChange)="filterMspOptions($event)"
                        placeholder="Search MSP" autocomplete="off">
                </div>
                <mat-option *ngFor="let organization of filteredMspList; trackBy: trackByOrgId" [value]="organization.orgId">
                    {{ organization.name }} {{ (organization.role == 0? "(Root)": organization.role
                    == 1? "(Master Msp)":organization.role == 2? "(Msp)": organization.role == 3?
                    "Organization": "") }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="org-filter">
            <mat-label>Organizations</mat-label>
            <mat-select formControlName="linked_orgs" (click)="searchFocus()" [multiple]="true"  (selectionChange)="onSelectOrgs($event)">
                <div class="dropdown-search">
                    <input #orginput [(ngModel)]="searchPipe" [ngModelOptions]="{standalone: true}" matInput
                        (ngModelChange)="filterOrgOptions($event)"
                        placeholder="Search Organization" autocomplete="off">
                </div>
                <div>
                    <mat-option *ngFor="let organization of filteredOrgList; trackBy: trackByOrgId"
                        [value]="organization.orgId">
                        {{ organization.name }} {{ (organization.role == 0? "(Root)": organization.role
                        == 1? "(Master Msp)":organization.role == 2? "(Msp)": organization.role == 3?
                        "Organization": "") }}
                    </mat-option>
                </div>
            </mat-select>
        </mat-form-field>
        <!-- <mat-form-field class="m-4">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startDate" [min]="minDate" [max]="maxDate" [formControl]="startMonth">
            <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate panelClass="example-date-picker">
            </mat-datepicker>
        </mat-form-field>
        <mat-form-field class="m-4">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endDate" [min]="startDate" [max]="maxDate" [formControl]="endMonth">
            <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate panelClass="example-date-picker">
            </mat-datepicker>
        </mat-form-field> -->
    </div>
    <div class="report-table">
        <table mat-table matTableExporter [dataSource]="reportMonthlyDataSource" #exporter="matTableExporter" matSort>
            <!-- <mat-table [dataSource]="reportMonthlyDataSource" style="width: 100%;" matTableExporter matSort> -->
                <ng-container matColumnDef="mmsp">
                    <th mat-header-cell *matHeaderCellDef>MMSP</th>
                    <td mat-cell *matCellDef="let element">{{element.mmsp}}</td>
                </ng-container>

                <ng-container matColumnDef="msp">
                    <th mat-header-cell *matHeaderCellDef>MSP</th>
                    <td mat-cell *matCellDef="let element">{{element.msp}}</td>
                </ng-container>

                <ng-container matColumnDef="org">
                    <th mat-header-cell *matHeaderCellDef>ORG</th>
                    <td mat-cell *matCellDef="let element">{{element.org}}</td>
                </ng-container>
                

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Hostname</th>
                    <td mat-cell *matCellDef="let element">{{element.name}}</td>
                </ng-container>

                <ng-container matColumnDef="mac">
                    <th mat-header-cell *matHeaderCellDef>Mac</th>
                    <td mat-cell *matCellDef="let element">{{element.mac.toUpperCase()}}</td>
                </ng-container>

                
                <ng-container matColumnDef="firmware">
                    <th mat-header-cell *matHeaderCellDef>Firmware</th>
                    <td mat-cell *matCellDef="let element">{{element.firmware}}</td>
                </ng-container>                

                <ng-container matColumnDef="model">
                    <th mat-header-cell *matHeaderCellDef>Model</th>
                    <td mat-cell *matCellDef="let element">
                        <span [innerHtml]="element.model"></span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="activationAt">
                    <th mat-header-cell *matHeaderCellDef>Activation Date</th>
                    <td mat-cell *matCellDef="let element">
                        <span [innerHtml]="element.activationAt"></span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="reportDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Report Date</th>
                    <td mat-cell *matCellDef="let element">{{element.reportDate}}</td>
                </ng-container>

                <ng-container matColumnDef="overlay">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Overlay</th>
                    <td mat-cell *matCellDef="let element">{{element.overlay}}</td>
                </ng-container>

                <ng-container matColumnDef="glte">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>4Glte</th>
                    <td mat-cell *matCellDef="let element">{{element.glte}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedReportColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedReportColumns"></tr>
            </table>        
    </div>
</mat-card>
